import { Injectable, OnDestroy } from '@angular/core';
import { Auth, IdTokenResult, User} from '@angular/fire/auth';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService implements OnDestroy {

  private destroy$ = new Subject<void>();
  public user$: Observable<User | null>;

  private roleSource = new BehaviorSubject<string>('User');
  public role$: Observable<string | null> = this.roleSource.asObservable();

  private companyIdSource = new BehaviorSubject<string>('');
  public clientId$: Observable<string | null> = this.companyIdSource.asObservable();

  acceptedConsent: boolean = false;

  constructor(
      private auth: Auth
  ) {
    // --- User Auth Subscription (unchanged) ---
    const unsubscribe = this.auth.onIdTokenChanged(user => {
      if (user) {
        user.getIdTokenResult().then(
          idTokenResult => this.processTokenResult(idTokenResult),
          error => {}
        );
      } 
    }, error => {

    });

    // Ensure we unsubscribe when the component is destroyed
    this.destroy$.subscribe(() => unsubscribe());
  } // End constructor


    private async processTokenResult(tokenResult: IdTokenResult | null): Promise<void> {
        if (!tokenResult) {
            return;
        }

        const clientId = tokenResult.claims['clientId'] as string;
        if (clientId && this.companyIdSource.getValue() !== clientId) {
            this.companyIdSource.next(clientId as string);
        } 

        const role = tokenResult.claims['role'] as string;
        if (role && this.roleSource.getValue() !== role)
        {
          this.roleSource.next(role)
        }
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
} // End class